var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.503,
    height: 22.521,
    viewBox: "0 0 19.503 22.521",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(-0.028 -0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11788",
    "data-name": "Path 11788",
    d: "M17.505,6.7h1.121a2.266,2.266,0,0,1,2.266,2.266V21.323a2.266,2.266,0,0,1-2.266,2.266H11.565A2.266,2.266,0,0,1,9.3,21.323",
    transform: "translate(-5.385 -3.877)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11789",
    "data-name": "Path 11789",
    d: "M25.875,12.248H27a2.266,2.266,0,0,1,2.266,2.266V26.874A2.266,2.266,0,0,1,27,29.141H19.935a2.266,2.266,0,0,1-2.266-2.266",
    transform: "translate(-10.231 -7.092)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    d: "M10.581,18.147H3.52a2.266,2.266,0,0,1-2.266-2.266V3.52A2.266,2.266,0,0,1,3.52,1.254h7.062A2.266,2.266,0,0,1,12.847,3.52V15.881A2.266,2.266,0,0,1,10.581,18.147Z",
    transform: "translate(-0.726 -0.726)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 6.416,
    transform: "translate(3.215 5.691)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 4.335,
    transform: "translate(3.215 8.531)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 2.428,
    transform: "translate(3.215 11.37)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIconBlue);
export default __webpack_public_path__ + "static/media/documentIconBlue.1520356c59a851fff55a4554eb8dc393.svg";
export { ForwardRef as ReactComponent };